export const ItemTypes = {
    MEDICAMENTO: 'medicamento',
    NONE: 'none',
    COMPRADO: 'comprado',
    USO: 'uso',
}